window.addEventListener('DOMContentLoaded', function () {
  const $galleries = $('.product__media-gallery');
  const $variant_inputs = $(".product-form__input input");
  const $size_guide_link = $('#sizeGuideBtn');
  const $size_section_accordion_tab = $("#size-section-accordion");
  $galleries.each(function () {
    initSlider($(this))
  })
  $variant_inputs.on("click",function(){
    addSelectedInputToOptionLabel($(this));
  });
  $size_guide_link.on("click",function(){
    $size_section_accordion_tab.children(".ctm-accordion-content").show();
});
})
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
      const later = () => {
          clearTimeout(timeout);
          func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
  };
}
function addSelectedInputToOptionLabel(element){
  value  = element.val();
  target = element.closest('.product-form__input').find('.dtc-option-value-picked');
  target.html(value);
}
document.addEventListener('dtc-scroll:image', debounce(function(e){
    selectActiveDot($(e.detail.slider), e.detail.currentPage - 1);
},100));
function initSlider($gallery) {
  generateDots($gallery)
  const $dots = $gallery.find('.dtc-product-image-slider-dots span');
  $dots.each(function () {
    $(this).on('click', function () {
      $(this).addClass('active').siblings().removeClass('active');
      const $index = $(this).data('index');
      setImageSlider($gallery, $index)
    })
  })
  $gallery.find('.slider-button--next').on('click', function () {
    clickEvent($gallery, 1)
  })
  $gallery.find('.slider-button--prev').on('click', function () {
    if ($currentIndex === 0) {
      return;
    }
    clickEvent($gallery, -1)
  })
  $('.thumbnail').on('click', function () {
    const $index = $(this).parent().index();
    selectActiveDot($gallery, $index);
  })
}
function templateDots($countSlides) {
  let $dots = '';
  for (let i = 0; i < $countSlides; i++) {
    $dots += `<span class="dot${i === 0 ? ' active' : ''}" data-index="${i}"></span>`
  }
  return $dots;
}
function generateDots($gallery) {
  const $countSlides = $gallery.find('.dtc-product-slider li').length;
  const $dotsContainer = $gallery.find('.dtc-product-image-slider-dots');

  $dotsContainer.each(function () {
    $(this).html(templateDots($countSlides))
  })
}
function setImageSlider($gallery, $index) {
  let $currentSlide = $gallery.find('.dtc-product-slider li').eq($index).find('button');
  $currentSlide.attr('aria-current', true).siblings().removeAttr('aria-current', false);
  $currentSlide.click();
  selectActiveDot($gallery, $index);
}
function clickEvent($gallery, $step) {
  const $activeElement = $gallery.find('.dtc-product-slider li button[aria-current="true"]');
  $currentIndex = $activeElement.closest('li').index();
  let $newIndex = $currentIndex + $step;
  setImageSlider($gallery, $newIndex);
  moveDesktopThumbs($gallery, $activeElement);
}
function selectActiveDot($gallery, $index) {
  $gallery.find('.dtc-product-image-slider-dots').find(`span[data-index="${$index}"]`).addClass('active').siblings().removeClass('active');
}
function moveDesktopThumbs($gallery, $activeElement) {

  if ($(window).width() < 1024) {
    return;
  }
  let $parentElement = $activeElement.parent();
  let $thumbsWrapper = $gallery.find('.dtc-slider-component');

  const scrolling_position = 4;

  let $dataDtcMediaPositionValue = parseInt($parentElement.attr('data-dtc-media-position'), 10);
  let $thumbnailHeight = $gallery.find('.thumbnail-slider-ctm li').outerHeight() + 30;

  let $top = ($dataDtcMediaPositionValue >= scrolling_position) ? $thumbnailHeight * ($dataDtcMediaPositionValue - scrolling_position) : 0;

  $thumbsWrapper.animate({
    scrollTop: $top
  }, 'slow');
}
